module.exports = __webpack_public_path__ + "img/H1.023e2475.png";